import { RefundStatusEnum } from '../../../generated/api.graphql';

export const RefundStatus = Object.freeze({
  NONE: RefundStatusEnum.None,
  PARTIAL: RefundStatusEnum.Partial,
  FULL: RefundStatusEnum.Full,
});
export type RefundStatus = (typeof RefundStatus)[keyof typeof RefundStatus];
